import { useAppSelector } from "../redux/hooks";
import { selectAuthRole } from "../redux/auth/auth.selectors";
import { useEffect } from "react";
import { LoginDialog } from "./login/login";
import { useNavigate } from "react-router-dom";

interface PageProps {
    roles: Array<string>;
    children: JSX.Element;
}

export const Page = ({ children, roles }: PageProps) => {
    const navigate = useNavigate();
    const role = useAppSelector(selectAuthRole);

    useEffect(() => {
        if (!roles.includes(role)) {
            navigate("/logout");
        }
    }, [navigate, role, roles]);

    return (
        <>
            <LoginDialog />
            {children}
        </>
    );
};
